import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Flags } from '../../../types/flags.type';

@Component({
  selector: 'app-mu-button',
  templateUrl: './mu-button.component.html',
  styleUrls: ['./mu-button.component.sass'],
})
export class MuButtonComponent<Flag> implements OnInit, AfterViewInit {
  /**
   * Button type
   */
  @Input() type = 'button';
  /**
   * Button Label
   */
  @Input() label: string;
  /**
   * Button icon
   */
  @Input() icon: string;
  /**
   * Icon position left, right
   */
  @Input() iconPos: string;
  /**
   * Is the button diabled
   */
  @Input() disabled = false;

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('class') clazz = '';

  /**
   * Flags used in the button
   */
  @Input() flagList: Flags<Flag>;

  /**
   * Flag that the button enable at click
   */
  @Input() flag: Flag;

  /**
   * Extra flag validations
   */
  @Input() extraLoadingFlags: Flag[];

  /**
   * When the button is clicked the flag is enabled
   */
  @Input() doEnableFlag = true;

  constructor() {
    /** */
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit() {
    /** */
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */

  ngAfterViewInit() {
    if (this.flagList || this.flag) {
      if (!(this.flagList && this.flag)) {
        throw new Error('flagList and flag must be used together');
      }
    }
  }

  /**
   * Enable the flag and prevent to call many times the button
   */
  eventClick(): void {
    if (this.flagList) {
      if (this.doEnableFlag) {
        this.flagList.enable(this.flag);
        return environment.guardClause;
      }
      this.flagList.disable(this.flag);
    }
  }

  /**
   * Get the calculate icon
   */
  get calculateIcon(): string {
    return this.icon ? `fa ${this.icon}` : '';
  }

  /**
   * show loading var value
   */
  get showLoading(): boolean {
    const flagValue = this.flagList?.get(this.flag);
    const baseFlagValue = this.doEnableFlag ? flagValue : !flagValue;
    if (baseFlagValue) {
      return true;
    }
    if (!this.extraLoadingFlags) {
      return false;
    }
    for (const flag of this.extraLoadingFlags) {
      const extraFlagValue = this.flagList?.get(flag);
      if (extraFlagValue) {
        return true;
      }
    }
    return false;
  }
}
